import { observable, action } from 'mobx';
import {
  getDocPlatformList,
  createDocPlatform as createDoc,
  updateDocPlatform,
} from '../server/homeServer';
import {
  CreateDocBody,
  UpdateDocBody,
} from '../Types';
import { get } from 'lodash';
import errCode from '@/utils/request/errCode';
import i18next from 'i18next';
import Message from '@/component/Message';

class CreateStore {
  @observable loadingDocPlatform = false;

  @observable currentInfo: any = null;

  @action
  // eslint-disable-next-line class-methods-use-this
  async createDocPlatform(data: CreateDocBody) {
    const result = await createDoc(data);
    if (result.code === 40109) {
      Message.error(i18next.t('doc_platform_name_exist'));
      return Promise.resolve('error');
    }
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('doc_platform_create_error'));
    }
    return Promise.resolve('success');
  }

  @action
  async fetchDocPlatformList(openSceneId: string, docPlatformId: number) {
    this.loadingDocPlatform = true;
    const result = await getDocPlatformList({
      openSceneId,
      docPlatformId,
    });
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('doc_platform_create_error'));
    }
    this.loadingDocPlatform = false;
    // eslint-disable-next-line prefer-destructuring
    this.currentInfo = get(result, 'data.docPlatformList', [null])[0];
  }

  @action
  // eslint-disable-next-line class-methods-use-this
  async updateDocPlatform(data: UpdateDocBody) {
    const result = await updateDocPlatform(data);
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('doc_platform_update_error'));
      return Promise.resolve('error');
    }
    Message.success(i18next.t('doc_platform_update_success'));
    return Promise.resolve('success');
  }
}
export default { name: 'homeStore', Store: CreateStore };
